<template>
  <BaseCard class="card-base flex flex-col items-center justify-around space-y-4 rounded-2xl text-center">
    <h2 class="text-xl">
      {{ title }}
    </h2>
    <slot>
      <NuxtLink
        class="btn btn-sm btn-primary w-content lg:btn-md"
        :to="{name: 'vacatures', query}"
      >
        Bekijk andere vacatures
      </NuxtLink>
    </slot>
  </BaseCard>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Staat jouw vacature er niet bij? Westerduin heeft altijd werk bij jou in de buurt!',
    },
    query: {
      type: Array,
      default: () => ([]),
    },
  },
};
</script>
